export default __webpack_public_path__ + "static/strapi-07e3f918db8bb08167fb933ddfc47fec.png";